import * as $ from "jquery";
import { Grid } from 'ag-grid-community';

export default class SellerDiscountsComponent {
    constructor() {
        this.componentSelector = "#ecom-seller-discounts";
        this.grid = null;
        this.instance = this;
    }

    init() {
        let instance = this;
        if ($(instance.componentSelector).length > 0) {
            instance.bind();
        }
    }

    bind() {
        let instance = this;
        $('#js-customer-discounts-search').off().on('click', function () {
            instance.search(instance);
        });

        $('.js-update-discount').off().on('click', function () {
            instance.update(instance);
        });

        $('.js-delete-discount').off().on('click', function () {
            instance.delete(instance);
        });

        $('#js-add-discount').off().on('click', function () {
            instance.showAddModal(instance);
        });

        $('#customermarket').off().on('change', function () {
            instance.search(instance);
        });

        $('.js-download-excel').off().on('click', function () {
            instance.download(instance);
        });

        const urlSearchParams = new URLSearchParams(window.location.search);
        const params = Object.fromEntries(urlSearchParams.entries());
        if (params.market != null) {
            if (params.market.trim() != "") {
                $('#customermarket').val(params.market);
            }
        }

        instance.search(instance);
    }

    download(instance) {
        var uri = "/pricelist/GetAllSellerDiscountsByMarket?marketId=" + $('#customermarket').val();

        var date = new Date();
        var fileName = "Säljarrabatter-" + date.toISOString().split('T')[0] + ".xlsx";
        let marketId = $('#customermarket').val();

        var x = new XMLHttpRequest();
        x.open("POST", uri, true);
        x.responseType = "blob";
        x.onload = function (e) { download(e.target.response, fileName, "application/vnd.ms-excel"); };

        var data = new FormData();
        data.append('marketId', marketId);
        x.send();

        if (typeof (callback) === 'function')
            callback();
    }

    update(instance) {
        let market = $('#customermarket').val();
        let roleId = 6; //Seller
        let discount = $('#discount').val();
        let brand = $('#brand').val();
        let itemcode = $('#itemcode').val();

        if (brand == "0") {
            bootbox.alert("Du måste välja ett varumärke.");
            return;
        }

        axios({
            method: 'post',
            url: "/pricelist/UpsertSellerDiscount",
            data: { marketId: market, roleId: roleId, sysId: brand, percentage: discount, itemcode: itemcode }
        }).then(function (response) {
            console.log(JSON.parse(response.data));
            instance.search(instance);
            setTimeout("$('#edit-modal').modal('hide');", 10);
        }).catch(function (response) {
            bootbox.alert("Ett fel inträfface.");
        });
    }

    delete(instance) {
        let market = $('#customermarket').val();
        let roleId = 6; //Seller
        let brand = $('#brand').val();
        let itemcode = $('#itemcode').val();

        axios({
            method: 'post',
            url: "/pricelist/DeleteSellerDiscount",
            data: { roleId: roleId, marketId: market, sysId: brand, itemcode: itemcode }
        }).then(function (response) {
            console.log(JSON.parse(response.data));
            instance.search(instance);
            setTimeout("$('#edit-modal').modal('hide');", 10);
        }).catch(function (response) {
            bootbox.alert("Ett fel inträfface.");
        });
    }

    search(instance) {
        let market = $('#customermarket').val();
        let roleId = 6; //Seller

        axios({
            method: 'post',
            url: "/pricelist/DiscountsBySeller",
            data: { roleId: roleId, marketId: market }
        }).then(function (response) {
            console.log(JSON.parse(response.data));
            instance.render(instance, JSON.parse(response.data));
        }).catch(function (response) {
            bootbox.alert("Inga priser matchade sökningen.");
        });
    }

    currencyFormatter(params) {
        return new Intl.NumberFormat('sv-SE', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(params.value);
    };

    buttonRenderer(params) {
        var button = document.createElement('button');
        button.innerHTML = 'Redigera';
        button.addEventListener('click', function () {
            params.context.showModal(params.value, params.data, params.context);
        });
        return button;
    }

    showModal(values, data, instance) {

        console.log(data);
        var fields = values.split("$");
        $('#discount').val(fields[0]);
        $('#brand').val(fields[1]);
        $('#itemcode').val(data.ItemCode);

        $('.js-delete-discount').show();
        $('#brand').prop("disabled", true);
        $('#itemcode').prop("disabled", true);

        setTimeout("$('#edit-modal').modal('show');", 10);
        setTimeout("$('#discount').focus();", 20);
    }

    showAddModal(data, instance) {
        $('#discount').val(0);
        $('#brand').val(0);
        $('#itemcode').val("");

        $('.js-delete-discount').hide();
        $('#brand').prop("disabled", false);
        $('#itemcode').prop("disabled", false);

        setTimeout("$('#edit-modal').modal('show');", 10);
        setTimeout("$('#discount').focus();", 20);
    }

    render(instance, data) {
        if (instance.grid == null) {
            instance.grid = {
                context: instance,
                columnDefs: [
                    { headerName: 'Roll', field: 'RoleName' },
                    { headerName: 'Varumärke', field: 'BrandName' },
                    { headerName: 'Artikelgrupp', field: 'ItemCode' },
                    { headerName: 'Varumärkesrabatt (%)', field: 'PercentDiscount', type: 'rightAligned' },
                    {
                        headerName: "",
                        field: 'Data',
                        cellRenderer: instance.buttonRenderer,
                        width: 160,
                    }
                ],
                rowData: data,
                defaultColDef: { sortable: true, filter: true },
                domLayout: 'autoHeight'
            };

            var eGridDiv = document.querySelector('#report');
            new Grid(eGridDiv, instance.grid);
        }
        else {
            instance.grid.api.setRowData(data);
        }


        $('#js-add-discount').show();
    }
}